import update from 'immutability-helper';
import range from 'lodash/range';
import flatten from 'lodash/flatten';
import fromPairs from 'lodash/fromPairs';
import compact from 'lodash/compact';
import pick from 'lodash/pick';
import _ from 'lodash';
import {
    WIDGET_CMP_LOADED,
    WIDGET_JSPROP_CHANGE,
    WIDGET_JSPROP_UPDATE_FILELD,
    WIDGET_SELECTED,
    WIDGET_FAV,
    EDITOR_TEMPLATE_CHANGE,
    EDITOR_RESET_WIDGET,
    // EDITOR,
    EDITOR_ZOOM,
    EDITOR_AUTO_ZOOM,
    EDITOR_TAB_OPEN,
    EDITOR_SET_TEMPLATE,
    WIDGETS_LOAD,
    //picker tab
    PICKER_OPEN_TAB,
    EDITOR_SET_PREVIEW_STATUS,
} from './constants';

const BASE_ALLOWED_KEYS = ['username', 'client', 'variation'];
const ALLOWED_KEY_REGEX = /(area|custom|text)\d{1,3}/gm;
const pickAllowedKeys = (jsprops, keys) => {
    // ...range(1, 12).map(i => `area${i}`),
    // ...range(1, 12).map(i => `custom${i}`),
    // ...range(1, 100).map(i => `text${i}`),

    const customProps = _.chain(jsprops)
        .toPairs()
        .filter(([key]) => key.match(ALLOWED_KEY_REGEX))
        .fromPairs()
        .value();
    console.log('!!!', jsprops);
    console.log('!!!', customProps);
    return { ...pick(jsprops, keys), ...customProps };
};

const weditor = {
    widgets: {},
    widgetId: null,
    cmps: [],
    jsprops: {},
    allowedKeys: [],
    zoom: 1.0,
    template: null,
    autozoom: true,
    preview: false,
    previewError: false,
};

export default (state = weditor, { type, payload }) => {
    switch (type) {
        case PICKER_OPEN_TAB: {
            return { ...state, picker: payload };
        }

        case EDITOR_SET_TEMPLATE: {
            return { ...state, template: payload };
        }

        case WIDGETS_LOAD: {
            const widgets = { ...state.widgets };
            widgets[payload.set] = payload.widgets;
            return { ...state, widgets };
        }

        case EDITOR_AUTO_ZOOM: {
            return { ...state, autozoom: payload };
        }

        case WIDGET_CMP_LOADED: {
            return { ...state, cmps: [...state.cmps, payload] };
        }

        case EDITOR_SET_PREVIEW_STATUS: {
            return { ...state, preview: payload.status, previewError: payload.error };
        }

        case WIDGET_JSPROP_UPDATE_FILELD: {
            const { field, update: _update } = payload;

            if (!_update) return state;

            return {
                ...state,
                jsprops: update(
                    state.jsprops,
                    !state.jsprops[field] ? { $merge: { [field]: _update } } : { [field]: { $merge: _update } },
                ),
                widgetProps: update(
                    state.widgetProps,
                    !state.widgetProps[field] ? { $merge: { [field]: _update } } : { [field]: { $merge: _update } },
                ),
            };
        }

        case WIDGET_JSPROP_CHANGE: {
            const { allowedKeys } = state;

            const widgetProps = pickAllowedKeys(
                { template: state.template, ...state.jsprops, ...payload },
                allowedKeys,
            );

            if (widgetProps.stageIds) {
                try {
                    widgetProps.stageIds = JSON.parse(widgetProps.stageIds);
                } catch (e) {
                    try {
                        widgetProps.stageIds = JSON.parse('[' + widgetProps.stageIds + ']');
                    } catch (e) {
                        widgetProps.stageIds = [];
                    }
                }
                if (!Array.isArray(widgetProps.stageIds)) {
                    widgetProps.stageIds = [widgetProps.stageIds];
                }
            }

            return {
                ...state,
                jsprops: { ...state.jsprops, ...payload },
                widgetProps,
            };
        }

        case WIDGET_FAV: {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    fav: true,
                },
            };
        }

        case EDITOR_TEMPLATE_CHANGE: {
            return {
                ...state,

                template: payload,
            };
        }

        case EDITOR_ZOOM: {
            return {
                ...state,
                zoom: payload.zoom || 1.0,
                autozoom: payload.autozoom,
            };
        }

        case EDITOR_TAB_OPEN: {
            return {
                ...state,
                tab: payload,
            };
        }

        case EDITOR_RESET_WIDGET: {
            return {
                ...state,
                widgetId: null,
                tab: 'layout',
                jsprops: null,
                widgetProps: null,
                widget: null,
                template: null,
            };
        }

        case WIDGET_SELECTED: {
            const { widget, params } = payload;
            // detect allowed keys
            const allowedKeys = [
                ...BASE_ALLOWED_KEYS,
                ...flatten(widget.spec.propTypes.map(p => (p.propsMap && Object.values(p.propsMap)) || p.key)),
            ];

            const baseJSProps = fromPairs(
                compact(widget.spec.propTypes.map(p => (p.defaultValue ? [p.key, p.defaultValue] : null))),
            );

            // jsprops = baseJSProps + userBaseProps + queryStrings

            const jsprops = { template: state.template, ...baseJSProps, ...params };

            return {
                ...state,
                widget: widget,
                widgetId: widget.id,
                allowedKeys,
                jsprops,
                widgetProps: pickAllowedKeys(jsprops, allowedKeys),
                baseJSProps,
            };
        }

        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/reducer.js
 **/